import { render, staticRenderFns } from "./review-step.vue?vue&type=template&id=33bc385c&scoped=true&"
import script from "./review-step.vue?vue&type=script&lang=js&"
export * from "./review-step.vue?vue&type=script&lang=js&"
import style0 from "./review-step.vue?vue&type=style&index=0&id=33bc385c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc385c",
  null
  
)

export default component.exports